/* ═══════════════════════════════════════════════════════════════════════
   Lake Life Designs — Product Recommendations (product-recs.js)
   Injects nearby-lake products into the recommendations carousel.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var container = document.getElementById('NearbyRecsContainer');
  if (!container) return;

  var collectionTitle = (container.getAttribute('data-collection') || '').trim();
  if (!collectionTitle) return;

  var showNearby = document.querySelector('.product-recs-section') &&
    !document.querySelector('[data-show-nearby="false"]');

  var NEARBY = {"Lanier":[{"name":"Burton","miles":43},{"name":"Allatoona","miles":44},{"name":"Blue Ridge","miles":45}],"Hartwell":[{"name":"Russell","miles":22},{"name":"Keowee","miles":26},{"name":"Jocassee","miles":38}],"Keowee":[{"name":"Jocassee","miles":12},{"name":"Hartwell","miles":26},{"name":"Burton","miles":39}],"Norman":[{"name":"Hickory","miles":25},{"name":"Wylie","miles":29},{"name":"James","miles":57}],"Wylie":[{"name":"Norman","miles":29},{"name":"Hickory","miles":49},{"name":"James","miles":69}],"Allatoona":[{"name":"Carters","miles":34},{"name":"Lanier","miles":44},{"name":"Weiss","miles":49}],"Blue Ridge":[{"name":"Nottely","miles":9},{"name":"Hiwassee","miles":21},{"name":"Chatuge","miles":28}],"Carters":[{"name":"Conasauga","miles":21},{"name":"Blue Ridge","miles":31},{"name":"Allatoona","miles":34}],"Oconee":[{"name":"Sinclair","miles":16},{"name":"Russell","miles":54},{"name":"Hartwell","miles":71}],"Sinclair":[{"name":"Oconee","miles":16},{"name":"Russell","miles":70},{"name":"Lanier","miles":82}],"Weiss":[{"name":"Guntersville","miles":37},{"name":"Allatoona","miles":49},{"name":"Conasauga","miles":57}],"Guntersville":[{"name":"Weiss","miles":37},{"name":"Nickajack","miles":60},{"name":"Wheeler","miles":64}],"Wheeler":[{"name":"Guntersville","miles":64},{"name":"Weiss","miles":102},{"name":"Nickajack","miles":103}],"Kerr":[{"name":"Gaston","miles":17},{"name":"Royale","miles":40},{"name":"Jordan","miles":69}],"Gaston":[{"name":"Kerr","miles":17},{"name":"Royale","miles":43},{"name":"Jordan","miles":82}],"Smith Mountain":[{"name":"Kerr","miles":84},{"name":"Jordan","miles":94},{"name":"Gaston","miles":100}],"Jordan":[{"name":"Royale","miles":50},{"name":"Kerr","miles":69},{"name":"Gaston","miles":82}],"Royale":[{"name":"Kerr","miles":40},{"name":"Gaston","miles":43},{"name":"Jordan","miles":50}],"Chickamauga":[{"name":"Watts","miles":33},{"name":"Nickajack","miles":36},{"name":"Conasauga","miles":37}],"Nickajack":[{"name":"Chickamauga","miles":36},{"name":"Conasauga","miles":42},{"name":"Weiss","miles":58}],"Watts":[{"name":"Fort Loudoun","miles":26},{"name":"Chickamauga","miles":33},{"name":"Norris","miles":51}],"Fort Loudoun":[{"name":"Watts","miles":26},{"name":"Norris","miles":31},{"name":"Fontana","miles":37}],"Norris":[{"name":"Fort Loudoun","miles":31},{"name":"Douglas","miles":37},{"name":"Watts","miles":51}],"Douglas":[{"name":"Norris","miles":37},{"name":"Fontana","miles":49},{"name":"Nantahala","miles":50}],"Hickory":[{"name":"Norman","miles":25},{"name":"James","miles":35},{"name":"Wylie","miles":49}],"James":[{"name":"Lure","miles":24},{"name":"Hickory","miles":35},{"name":"Norman","miles":57}],"Lure":[{"name":"James","miles":24},{"name":"Hickory","miles":52},{"name":"Jocassee","miles":56}],"Russell":[{"name":"Hartwell","miles":22},{"name":"Keowee","miles":48},{"name":"Oconee","miles":54}],"Jocassee":[{"name":"Keowee","miles":12},{"name":"Hartwell","miles":38},{"name":"Burton","miles":39}],"Burton":[{"name":"Chatuge","miles":11},{"name":"Nottely","miles":30},{"name":"Blue Ridge","miles":37}],"Chatuge":[{"name":"Burton","miles":11},{"name":"Nottely","miles":20},{"name":"Blue Ridge","miles":28}],"Nottely":[{"name":"Blue Ridge","miles":9},{"name":"Hiwassee","miles":19},{"name":"Chatuge","miles":20}],"Nantahala":[{"name":"Fontana","miles":12},{"name":"Hiwassee","miles":34},{"name":"Chatuge","miles":35}],"Fontana":[{"name":"Nantahala","miles":12},{"name":"Hiwassee","miles":28},{"name":"Fort Loudoun","miles":37}],"Hiwassee":[{"name":"Nottely","miles":19},{"name":"Blue Ridge","miles":21},{"name":"Fontana","miles":28}],"Conasauga":[{"name":"Carters","miles":21},{"name":"Chickamauga","miles":37},{"name":"Blue Ridge","miles":40}]};

  function esc(s) {
    return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Find the lake key from the collection title ─────────────────────── */
  function findLakeKey(title) {
    var hay = title.toLowerCase();
    var best = null, bestLen = 0;
    Object.keys(NEARBY).forEach(function(k) {
      if (hay.indexOf(k.toLowerCase()) !== -1 && k.length > bestLen) {
        best = k; bestLen = k.length;
      }
    });
    return best;
  }

  /* ── Fetch products from a collection via Predictive Search ─────────── */
  function fetchCollection(term) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(term)
      + '&resources[type]=collection&resources[limit]=1', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) { return r.ok ? r.json() : {}; })
    .then(function(d) {
      var colls = (d.resources && d.resources.results && d.resources.results.collections) || [];
      return colls[0] ? colls[0].url : null;
    })
    .catch(function() { return null; });
  }

  /* ── Fetch products from a collection URL via AJAX ──────────────────── */
  function fetchCollectionProducts(collUrl, limit) {
    return fetch(collUrl + '.json?limit=' + (limit || 6))
      .then(function(r) { return r.ok ? r.json() : {}; })
      .then(function(d) { return (d.products || []); })
      .catch(function() { return []; });
  }

  /* ── Build a product card HTML string ───────────────────────────────── */
  function buildCard(product) {
    var img = (product.images && product.images[0]) ? product.images[0].src : '';
    var imgMarkup = img
      ? '<img class="rec-card__img" src="' + esc(img.replace(/(\.\w+)$/, '_400x$1')) + '" alt="' + esc(product.title) + '" loading="lazy">'
      : '<div class="rec-card__img rec-card__img--placeholder"></div>';
    var price = product.variants && product.variants[0]
      ? '$' + (product.variants[0].price / 100).toFixed(2)
      : '';
    return '<a href="/products/' + esc(product.handle) + '" class="rec-card rec-card--nearby">'
      + '<div class="rec-card__img-wrap">' + imgMarkup + '</div>'
      + '<div class="rec-card__body">'
      + '<span class="rec-card__nearby-label">Nearby Lake</span>'
      + '<p class="rec-card__title">' + esc(product.title) + '</p>'
      + '<p class="rec-card__price">' + esc(price) + '</p>'
      + '</div>'
      + '</a>';
  }

  /* ── Main ────────────────────────────────────────────────────────────── */
  var lakeKey = findLakeKey(collectionTitle);
  if (!lakeKey || !NEARBY[lakeKey]) return;

  var nearbyList = NEARBY[lakeKey];

  Promise.all(nearbyList.map(function(entry) {
    return fetchCollection(entry.name).then(function(collUrl) {
      if (!collUrl) return [];
      return fetchCollectionProducts(collUrl, 4);
    });
  })).then(function(results) {
    var cards = [];
    results.forEach(function(products) {
      products.slice(0, 3).forEach(function(p) {
        cards.push(buildCard(p));
      });
    });
    if (cards.length > 0) {
      container.innerHTML = cards.join('');
    }
  }).catch(function(e) { console.warn('Nearby recs error:', e); });


  /* Arrow init handled by carousel-init.js */

})();
